import { render } from "./ReportProblemForm.vue?vue&type=template&id=16bf3499&scoped=true"
import script from "./ReportProblemForm.vue?vue&type=script&lang=js"
export * from "./ReportProblemForm.vue?vue&type=script&lang=js"

import "./ReportProblemForm.vue?vue&type=style&index=0&id=16bf3499&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Raska\\Desktop\\raska\\projekat\\astra\\astra-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16bf3499"]])

export default __exports__